"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMultiSelect = exports.serializeMultiSelect = void 0;
const serializeMultiSelect = (item) => {
    const itemOptions = item.data.items;
    if (!Array.isArray(itemOptions) ||
        !itemOptions.some(({ checked }) => checked)) {
        return "";
    }
    return itemOptions
        .filter(({ checked }) => checked)
        .map(({ text }) => text)
        .join(", ");
};
exports.serializeMultiSelect = serializeMultiSelect;
const validateMultiSelect = (item) => {
    if (!item.required || item.data.items?.find((item) => item.checked)) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Select at least one." } };
};
exports.validateMultiSelect = validateMultiSelect;
//# sourceMappingURL=multiSelect.js.map